var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 16.6667C5.83333 15.2859 7.69881 14.1667 10 14.1667C12.3012 14.1667 14.1667 15.2859 14.1667 16.6667M15 11.8746C16.4716 12.2604 17.5 13.1414 17.5 14.1666M5 11.8746C3.52841 12.2604 2.5 13.1414 2.5 14.1666M15 8.53008C15.5115 8.07231 15.8333 7.40707 15.8333 6.66666C15.8333 5.28594 14.714 4.16666 13.3333 4.16666C12.693 4.16666 12.109 4.40737 11.6667 4.80323M5 8.53008C4.48854 8.07231 4.16667 7.40707 4.16667 6.66666C4.16667 5.28594 5.28595 4.16666 6.66667 4.16666C7.30696 4.16666 7.89104 4.40737 8.33333 4.80323M12.5 9.16666C12.5 10.5474 11.3807 11.6667 10 11.6667C8.61929 11.6667 7.5 10.5474 7.5 9.16666C7.5 7.78594 8.61929 6.66666 10 6.66666C11.3807 6.66666 12.5 7.78594 12.5 9.16666Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/UserGroup.2ddab485.svg";
export { ForwardRef as ReactComponent };